import CategoryPriceLimitService from '../../services/CategoryPriceLimitService';
import categoryPriceLimitUseCase from './categoryPriceLimitUseCase';

const categoryPriceLimitFactory = categoryPriceLimitUseCase({
  CategoryPriceLimitService: CategoryPriceLimitService(),
});

export default categoryPriceLimitFactory;
